import { Divider, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material"
import { AddCircleOutlined, DeleteOutlined, EditOutlined, PauseCircleOutlined } from "@mui-symbols-material/w300"
import React from "react"

import type { Instruction } from "@/graphql/codegen/graphql"

interface InstructionDropdownMenuProps {
  anchorEl: HTMLElement | null
  onClose: () => void
  open: boolean
  onToggleActive: () => void
  fetchingProducts?: boolean
  hasProducts: boolean
  onRemoveProducts: () => void
  instruction: Instruction
  onEditInstruction: (instruction: Instruction) => void
}

const MENU_ICON_PROPS = {
  fontVariationSettings: '"wght" 300',
}

const InstructionDropdownMenu: React.FC<InstructionDropdownMenuProps> = ({
  anchorEl,
  onClose,
  open,
  instruction,
  onEditInstruction,
  onToggleActive,
  fetchingProducts,
  hasProducts,
  onRemoveProducts,
}) => {
  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      slotProps={{
        paper: {
          className: "w-[200px]",
        },
      }}
    >
      <MenuItem onClick={() => onEditInstruction(instruction)}>
        <ListItemIcon>
          <EditOutlined sx={MENU_ICON_PROPS} />
        </ListItemIcon>
        <ListItemText primary='Edit Instruction' />
      </MenuItem>
      <MenuItem onClick={onToggleActive} disabled={fetchingProducts}>
        <ListItemIcon>
          {instruction.isActive ? (
            <PauseCircleOutlined sx={MENU_ICON_PROPS} />
          ) : (
            <AddCircleOutlined sx={MENU_ICON_PROPS} />
          )}
        </ListItemIcon>
        <ListItemText primary={instruction.isActive ? "Deactivate" : "Activate"} />
      </MenuItem>
      {hasProducts && (
        <>
          <Divider />
          <MenuItem onClick={onRemoveProducts}>
            <ListItemIcon>
              <DeleteOutlined sx={MENU_ICON_PROPS} />
            </ListItemIcon>
            <ListItemText primary='Remove Products' />
          </MenuItem>
        </>
      )}
    </Menu>
  )
}

export default InstructionDropdownMenu
